import {Theme} from '@mui/material';

export const containerWidth = (theme: Theme, {upLg = {}, betweenSmLg = {}} = {}) => ({
  [theme.breakpoints.up('lg')]: {
    maxWidth: theme.shape.sectionContainerMaxWidth.lg,
    ...upLg,
  },

  [theme.breakpoints.between('sm', 'lg')]: {
    maxWidth: theme.shape.sectionContainerMaxWidth.sm,
    ...betweenSmLg,
  },
});
